import { CircularProgress, Stack, Skeleton } from "@mui/material";
//import {  Height, Plagiarism } from '@mui/icons-material';
import dataEmpty from '../picture/empty.png';

const Nodata = (props) => {
    const style = {
        marginTop: (props.mt) ? `${props.mt}%` : '25%',
        color: '#b2b2b2',
        fontSize: '20px',
    };

    return (
        <>
            {
                (() => {
                    if (props.loading) {
                        return (
                            <main style={style}>
                                <div className="textAlign-center">
                                    <CircularProgress sx={{ marginTop: '50px', display: 'none' }} />
                                </div>
                            </main>
                        )
                    } else if (props.val == 0) {
                        return (
                            <main style={style}>
                                <div className="textAlign-center">
                                    {/*<p><FindInPage style={{ fontSize: '70px' }} /></p>*/}
                                    <img
                                        src={dataEmpty}
                                        alt=""
                                        loading="lazy"
                                        style={{ width: '80px' }}
                                    />
                                    <p style={{ fontSize: '20px', fontWeight: 'bold' }}>{(props.mainmessage != null) ? props.mainmessage : 'ບໍ່ພົບຂໍ້ມູນ'}</p>
                                    {props.submessage != '' && <p style={{ fontSize: '16px', marginBottom: '-5px' }}>{props.submessage}</p>}
                                    {props.submessage2 != '' && <p style={{ fontSize: '16px' }}>{props.submessage2}</p>}
                                </div>
                            </main>
                        )
                    }
                })()
            }
        </>
    )
}
export default Nodata